<section class="form-view-main-wrapper full">
  <!-- <div>Template Configuration Properties: New Template Name, Description, Keywords etc.</div> -->
  <div>StagingTemplateID: {{ editTemplateService.newDocumentTemplate.StagingTemplateID }}</div>
  <div>
    StagingTemplateFileName: {{ editTemplateService.newDocumentTemplate.StagingTemplateFileName }}
  </div>
  <div class="form-toolbar">
    <form [formGroup]="filterForm">
      <div class="form-toolbar-header">
        <div class="form-row mb-3">
          <input
            class="c-control"
            type="text"
            placeholder="Search..."
            formControlName="searchString"
            />
          </div>
          <div class="form-row mb-3">
            <select class="c-control" formControlName="columnName">
              <option value="{{ allColumnsFilterName }}">{{ allColumnsFilterName }}</option>
              @for (colName of columnNames; track colName) {
                <option value=" {{ colName }}">
                  {{ colName }}
                </option>
              }
            </select>
          </div>
        </div>
      </form>
      <button (click)="uploadMappings()">UPLOAD TEMPLATE</button>
    </div>
    <div class="grid-container">
      <app-grid
        [gridName]="'editTemplate'"
        [columnDefs]="columnDefs"
        [gridData]="editTemplateService.filteredTempJson"
        [showLoadingIndicator]="!isTemplateViewReady"
      ></app-grid>
    </div>
  </section>
